// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__2sI8J","simpleListItem":"List_simpleListItem__3Y6AE","item":"List_item__3mwhQ","title":"List_title__3sqyi"};